import { render, staticRenderFns } from "./data88.vue?vue&type=template&id=14278eb8&scoped=true"
import script from "./data88.vue?vue&type=script&lang=js"
export * from "./data88.vue?vue&type=script&lang=js"
import style1 from "./data88.vue?vue&type=style&index=1&id=14278eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14278eb8",
  null
  
)

export default component.exports